export default __webpack_public_path__ + "img/6a8bc7acd205391fb71a9326938d6b63.woff2";